import PropTypes from 'prop-types';

import partnerShape from './partnerShape';
import storeShape from './storeShape';

const gglocationShape = PropTypes.oneOfType([storeShape, partnerShape]);

export default gglocationShape;
